<template>
  <div>
    <v-list flat dense class="py-0" v-if="showAddresses">
      <v-list-item-group>
        <v-list-item class="text-left border-bottom" flat v-for="address in addresses.addresses" :key="'address_list_'+address.address_id" @click="select(address)">
          <v-list-item-action class="ml-1 mr-2">
            <v-checkbox
              :input-value="selectedAddress && selectedAddress.address_id === address.address_id"
              color="primary"
              dense>
            </v-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="subtitle-2">
              <div v-if="$vuetify.breakpoint.mdAndUp">
                <span class="font-weight-bold grey--text text--darken-3">{{ address.address }}</span>
                <span class="grey--text text--darken-1" v-if="address.additional_address">
                  {{ address.additional_address }},
                </span>
                <span class="grey--text text--darken-1">
                  {{ address.neighborhood }}, {{ address.city.name }}, {{ address.region.name }}
                </span>
              </div>
              <div v-else>
                <span class="font-weight-bold grey--text text--darken-3">{{ address.address }}</span>
              </div>
            </v-list-item-title>
            <v-list-item-subtitle  class="subtitle-2" v-if="$vuetify.breakpoint.smAndDown">
              <div v-if="$vuetify.breakpoint.smOnly">
                <span class="grey--text text--darken-1" v-if="address.additional_address">
                  {{ address.additional_address }},
                </span>
                <span class="grey--text text--darken-1">
                  {{ address.neighborhood }}, {{ address.city.name }}, {{ address.region.name }}
                </span>
              </div>
              <div v-else>
                <span class="grey--text text--darken-1">
                  {{ address.city.name }}, {{ address.region.name }}
                </span>
              </div>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon v-on:click.stop="edit(address)">
              <v-icon color="blue">edit</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-list-item class="text-left add-item" flat @click="add">
      <v-list-item-icon class="mx-1">
        <v-icon color="blue" dense>add</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="subtitle-2 blue--text" v-if="isAuthenticated">Nueva dirección</v-list-item-title>
        <v-list-item-title class="subtitle-2 blue--text" v-else>Agregar dirección</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import navigationMixin from '@/mixins/navigation'

export default {
  name: 'AddressList',
  mixins: [navigationMixin],
  props: {
    selectedAddress: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      modifyAddress: undefined
    }
  },
  computed: {
    ...mapState('shared', ['error']),
    ...mapState('auth', ['isAuthenticated']),
    ...mapState('address', ['addresses']),
    showAddresses () {
      const addresses = this.addresses
      return !!addresses && !!addresses.addresses && addresses.addresses.length > 0
    }
  },
  methods: {
    ...mapActions('address', ['getAddresses']),
    select (address) {
      this.$emit('select', address)
    },
    edit (address) {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.$emit('openModal', address)
        return
      }

      this.$emit('edit', address)
    },
    add () {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.$emit('openModal')
        return
      }

      this.$emit('add')
    },
    modalClosed () {
      this.modifyAddress = undefined
    }
  },
  async mounted () {
    if (!this.isAuthenticated) {
      return
    }

    await this.getAddresses()
    const addresses = this.addresses
    if (!this.selectedAddres && !!addresses && !!addresses.addresses && addresses.addresses.length === 1) {
      this.$emit('select', this.addresses[0])
    }
  }
}
</script>

<style scoped>
  .border-bottom{
    border-bottom: 1px solid;
    border-color: rgba(0, 0, 0, 0.12);
  }
  .add-item{
    cursor: pointer;
    height: 54px;
  }
</style>
